<template>
  <div class="card_bar_content_new topView">
    {{ cardContent }}
  </div>
</template>

<script>

export default {
  name: "TopToolBarContent",
  data() {
    return {
      showContent: true,
    };
  },
  computed: {
    cardShow() {
      return typeof this.$store.state?.vuex_cardInfo?.title !== 'undefined';
    },
    cardTitle() {
      return this.$store.state?.vuex_cardInfo?.title || '';
    },
    cardContent(){
      return this.$store.state?.vuex_cardInfo?.content || '';
    }

  },
  mounted () {
  },

  methods: {

  },
};
</script>

<style lang="less" scoped>
  .card_bar_content_new{
    position: absolute;
    float: left;
    width: 91px;
    // height: 81px;
    background: rgba(0, 0, 0, 0.3);
    // border-radius: 6px;
    // backdrop-filter: blur(8px);

    top: 102px; // 12 + 50 + 12 // 上下圆角问题 主动上移动覆盖 4px
    left: 16px;

    // padding: 0 10px;

    font-weight: 400;
    font-size: 11px;
    color: #FFFFFF;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    padding: 4px 8px 4px 8px;
    box-sizing: border-box;
    z-index: -1;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;

  }
  .topView{
    z-index: 48; // 避免被输入条覆盖
    /*transform: translateZ(49px) ; !*这里是给safari用的z-index*!
    -webkit-transform:translateZ(49px);
    -moz-transform:translateZ(49px);
    -o-transform:translateZ(49px);*/
  }

</style>
